import cx from "classnames"
import React from "react"
import * as css from "./Typography.module.css"

const componentFactory = (el, baseClassName) => {
  const El = el

  // eslint-disable-next-line func-names
  return ({ children, className, weight, ...rest }) => {
    const classNames = {
      [css.weightMedium]: weight === "medium",
      [css.weightBold]: weight === "bold",
    }
    return (
      <El className={cx(baseClassName, className, classNames)} {...rest}>
        {children}
      </El>
    )
  }
}

/** Paragraph level 1 */
export const P1 = componentFactory("p", css.p1)

/** Paragraph level 2 */
export const P2 = componentFactory("p", css.p2)

/** Paragraph level 3 */
export const P3 = componentFactory("p", css.p3)

/** Header level 1 */
export const H1 = componentFactory("h1", css.h1)

/** Header level 2 */
export const H2 = componentFactory("h2", css.h2)

/** Header level 3 */
export const H3 = componentFactory("h3", css.h3)

/** Header level 4 */
export const H4 = componentFactory("h4", css.h4)

/** Trademark */
export function TM({ className }) {
  return <sup className={cx(css.trademark, className)}>™</sup>
}
